import { useRef } from "react";
import { Plus, X } from "@phosphor-icons/react";

// Multi-file picker with a "+" Add file button, a chip list of picked files,
// and per-file remove ✕. Fully controlled: pass `files` (array of File) + `onChange`.
export function MultiFilePicker({ files, onChange, testid = "file-picker", required, hint }) {
  const inputRef = useRef();
  const add = (list) => {
    const arr = Array.from(list || []);
    if (!arr.length) return;
    onChange([...files, ...arr]);
  };
  const removeAt = (i) => onChange(files.filter((_, idx) => idx !== i));
  const openPicker = () => inputRef.current?.click();

  return (
    <div>
      <input
        ref={inputRef}
        type="file"
        multiple
        hidden
        onChange={(e) => { add(e.target.files); if (inputRef.current) inputRef.current.value = ""; }}
        data-testid={`${testid}-input`}
      />
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={openPicker}
          data-testid={`${testid}-add-btn`}
          className="text-sm border border-dashed border-zinc-300 bg-white px-3 py-2 hover:bg-zinc-50 inline-flex items-center gap-1.5 text-zinc-700 transition-colors duration-150"
        >
          <Plus size={14} /> {files.length ? "Add another file" : "Add file"}
        </button>
        {!files.length && (
          <div className="text-xs text-zinc-400 font-mono">
            {required ? "at least one required" : (hint || "optional")}
          </div>
        )}
        {files.length > 0 && (
          <div className="text-xs text-zinc-500 font-mono">
            {files.length} file{files.length === 1 ? "" : "s"} attached
          </div>
        )}
      </div>
      {files.length > 0 && (
        <ul className="mt-2 space-y-1" data-testid={`${testid}-list`}>
          {files.map((f, i) => (
            <li
              key={`${f.name}-${i}`}
              className="flex items-center justify-between text-xs border border-zinc-200 bg-zinc-50 px-2.5 py-1.5 font-mono"
              data-testid={`${testid}-item-${i}`}
            >
              <span className="truncate mr-2">
                <span className="text-zinc-900">{f.name}</span>
                <span className="text-zinc-400"> · {(f.size / 1024).toFixed(1)} KB</span>
              </span>
              <button
                type="button"
                onClick={() => removeAt(i)}
                data-testid={`${testid}-remove-${i}`}
                className="text-red-700 hover:bg-red-100 p-1 -m-1"
                title="Remove file"
              >
                <X size={12} weight="bold" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
